import futVector from "@/assets/football-vector.png";
import { FutButton } from "@/components/FutButton";
import styled from "styled-components";
import { Checkbox, styled as muiStyled } from "@mui/material";
import { customScroll } from "@/styles/globalStyles";

//--------------------- BASE -----------------------------

export const BackgroundVector = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 100%;
  background: url(${futVector});
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: contain;
  z-index: -1;
`;

export const Navigation = styled.nav`
  position: sticky;
  top: 0;
  width: 100%;
  height: 60px;
  background-color: red;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 35px;
  background-color: #242C35;
  z-index: 2;
  img {
    max-width: 100%;
    width: 150px;
  }

  @media only screen and (max-width: 1200px) {
    padding: 0 10px;
  }
`;

export const LoginButton = muiStyled(FutButton)`
  padding: 5px 25px;
`;

export const ModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${(props) => props.theme.backgroundColor};

  border-radius: 5px;
  text-align: center;
  width: 300px;
  padding: 30px 0;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
  .MuiCircularProgress-root {
    width: 100px !important;
    height: 100px !important;
  }
`;

//--------------------- PART 1 -----------------------------

export const IndicationContainer = styled.div`
 width: 300px;
 background-color: ${props => props.theme.backgroundColor};
 border-radius: 5px;
 padding: 24px;
 text-align: center;
 display: flex;
 flex-direction: column;
  h2 {

  }
  p {
    font-weight: bold;
    border-bottom: solid 1px  ${(props) => props.theme.primary};
    animation: underline 5s infinite;
    box-shadow: 0px 10px 10px -9px ${props => props.theme.primary};
    margin: 10px 0;
    padding: 5px;
    width: fit-content;
    max-width: 250px;
    align-self: center;
    transition: ease-in 400ms;
    word-wrap: break-word;
  }

  @keyframes underline {
    0% {
      box-shadow: 0px 10px 10px -9px ${props => props.theme.primary};

    }
    50% {
      box-shadow: 0px 10px 10px -15px ${props => props.theme.primary};
  
    }
    100% {
      box-shadow: 0px 10px 10px -9px ${props => props.theme.primary};
    }
  }
`

export const BenefitsWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 24px;
  border-radius: 5px;
  height: 100%;
  margin: 0 10px;
  max-width: 365px;
`;

export const Container = styled.div`
  transition: all 400ms ease-in-out;
`;

export const BenefitsContainer = styled.div`
  margin: 10px;
  padding: 24px 16px;
  gap: 10px;
  display: flex;
  align-items: center;
  background-color: ${(props) => props.theme.bottomColor};
  border-radius: 5px;
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      min-width: 40px;
      min-height: 40px;
      color: ${(props) => props.theme.primary};
    }
  }
`;

export const OurPlansWrapper = styled.div`
  padding: 24px;
  background-color: ${(props) => props.theme.backgroundColor};
  height: 100%;
  border-radius: 5px;
  margin: 0 10px;
  max-width: 365px;
`;

export const PlansButton = styled.button`
  margin-top: 24px;
  background-color: ${(props) => props.theme.selectColor};
  padding: 24px 16px;
  border-radius: 5px;
  width: 100%;
  border: unset;
  box-shadow: -3px 4px 11px 0px rgba(0, 0, 0, 0.2);
  text-align: left;
  position: relative;

  span {
    font-size: 1.3rem;
  }
  p {
    margin-top: 5px;
    span {
      font-size: 0.9rem;
      text-decoration: line-through;
      color: ${(props) => props.theme.fontColor}80;
    }
  }
`;

export const DiscountTag = styled.div`
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0px;
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  p {
    margin: 0;
    padding: 4px;
    color: ${(props) => props.theme.secondary};
    background-color: ${(props) => props.theme.secondary}1a;
    border-radius: 5px;
  }
`;

//--------------------- PART 2 -----------------------------

export const RegisterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;

export const RegisterContainer = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  width: 450px;
  max-width: 450px;
  padding: 32px;
  margin: 0 10px;
  border-radius: 5px;
`;

export const RegisterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
  div {
    display: flex;
    p {
      font-size: 1.3em;
    }
  }

  p {
    display: flex;
    align-items: center;
  }

  button {
    display: flex;
    align-items: center;
    background-color: transparent;
    border: none;
    margin-right: 5px;
    font-size: 1.3rem;
  }
`;

export const RegisterBody = styled.div`
  div {
    margin-bottom: 5px;
  }
`;
export const JoinInputs = styled.div`
  display: flex;
  gap: 15px;

  div {
    flex-basis: 50%;
  }

  @media (max-width: 375px) {
    flex-direction: column;
    gap: 0;
  }
`;

export const RegisterFooter = styled.div`
  margin-top: 15px;
`;

//--------------------- PART 3 -----------------------------

export const MethodsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;

export const MethodsContainer = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  width: 450px;
  max-width: 450px;
  padding: 32px;
  margin: 0 10px;
  border-radius: 5px;
`;

export const RadioContainer = styled.label`
  display: flex;
`;

export const RadioNameContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const TermServicesContainer = styled.div`
  span {
    color: ${(props) => props.theme.primary};
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const ModalWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const TermServicesModalCont = styled.div`
  position: relative;
  display: flex;
  max-width: 520px;
  flex-direction: column;
  margin-top: 15px;
  border-radius: 5px;
  max-height: 95vh;
  overflow: auto;
  background-color: ${(props) => props.theme.backgroundColor};
  
`;

export const TermsHeader = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  position: sticky;
  top: 0;
  display: flex;
  justify-content: flex-end;
  span {
    display: flex;
    cursor: pointer;
    user-select: none;
    margin: 10px;
  }
  svg {
    font-size: 30px;
  }
`;
export const TermsTextCont = styled.div`
  padding: 20px;
  padding-top: 0;
  p {
    margin-top: 10px;
  }

  h2 {
    margin-top: 10px;
  }
`;

// export const PixQrContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   gap: 10px;
// `;

// export const CopyPixContainer = styled.div`
//   display: flex;
//   gap: 10px;
// `;

// export const PixStepsContainer = styled.div`
//   margin-top: 30px;
//   div {
//     display: flex;
//     align-items: center;
//     gap: 10px;
//     span {
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       width: 30px;
//       height: 30px;
//       border-radius: 50px;
//       background-color: ${(props) => props.theme.primary};
//     }
//   }
// `;

// export const CheckBoxContainer = styled.div`
//   display: flex;

//   a {
//     color: #fff;
//     margin-top 10px;
//     &:hover {
//       color: ${(props) => props.theme.primary};
//     }
//   }
// `;
// export const StyledCheckbox = muiStyled(Checkbox)`
//   color: 'red'
// `
